export default {
  jobs: "jobs",
  categories: "categories",
  stats: (param) =>
    `election/stats/${param.entity}?electionCode=${param.electionCode}`,
  profile: "candidate/profile",
  GET_APPLICATION: (id) => `job-applications/application?no=${id}`,
};
